import { Component } from '@angular/core';

@Component({
  selector: 'dl-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css'],
})
export class DlPageHeaderComponent {}
